import axios from 'axios';
import {
  ADD_ORDERED_RULES,
  BACKUP_RULES,
  FETCH_RULES_SUCCESS,
  FETCH_SUBTYPES_SUCCESS,
  FETCHING_RULES,
  RE_ORDER_RULES_SUCCESS,
  REMOVE_ORDERED_RULE,
  RESTORE_RULES,
  UPDATE_SELECTED_RULES_SUCCESS,
  VALIDATE_RULE_SUCCESS,
  CREATE_RULE_SUCCESS,
  CREATING_RULE,
  VALIDATING_RULE,
  RESET_RULE_CREATOR,
  VALIDATE_RULE_ERROR,
  VALIDATE_RULE_RESET,
  FETCHING_RULE,
  FETCH_RULE_SUCCESS,
  APPLYING_ALLOCATION_RULE,
  APPLY_ALLOCATION_SUCCESS
} from './RulesConstants';
import { fetchInvoiceJurisdictionalBreakdown } from 'redux/invoiceDetail/InvoiceDetailActions';
import { fetchInvoiceById, fetchInvoicesLines } from "../invoices/InvoicesActions";

const fetchRulesSuccess = (rules, pageState) => ({
  type: FETCH_RULES_SUCCESS,
  rules,
  pageState
});
const fetchingRules = pageStats => ({ type: FETCHING_RULES, pageStats });
const backupRulesSuccess = () => ({ type: BACKUP_RULES });
const restoreRulesSuccess = () => ({ type: RESTORE_RULES });
const updateSelectedRulesSuccess = rule => ({
  type: UPDATE_SELECTED_RULES_SUCCESS,
  rule
});
const addOrderedRulesSuccess = () => ({ type: ADD_ORDERED_RULES });
const reOrderRulesSuccess = (startIndex, endIndex, subtype) => ({
  type: RE_ORDER_RULES_SUCCESS,
  startIndex,
  endIndex,
  subtype
});
const removeOrderedRuleSuccess = (index, subtype) => ({
  type: REMOVE_ORDERED_RULE,
  index,
  subtype
});
const validatingRule = () => ({
  type: VALIDATING_RULE,
  validationResult: 'Validating Result...'
});
const validateRuleSuccess = validationResult => ({
  type: VALIDATE_RULE_SUCCESS,
  validationResult
});
const validateRuleError = () => ({ type: VALIDATE_RULE_ERROR });
const fetchSubtypesSuccess = subtypes => ({
  type: FETCH_SUBTYPES_SUCCESS,
  subtypes
});
const createRuleSuccess = () => ({ type: CREATE_RULE_SUCCESS });
const creatingRule = () => ({ type: CREATING_RULE });
const resetRuleCreatorSuccess = () => ({ type: RESET_RULE_CREATOR });
const validationRuleReset = () => ({ type: VALIDATE_RULE_RESET });
const fetchingRule = () => ({ type: FETCHING_RULE });
const fetchRuleSuccess = rule => ({ type: FETCH_RULE_SUCCESS, rule });
const applyingAllocationRule = () => ({ type: APPLYING_ALLOCATION_RULE });
const allocationAppliedSuccess = () => ({ type: APPLY_ALLOCATION_SUCCESS });

const path = 'utm/v1/rules';

const fetchRules = (page = 0, perPage = 10) => dispatch => {
  dispatch(fetchingRules({ page, perPage }));
  axios
    .get(`${path}?page=${page}&perPage=${perPage}`)
    .then(rulesResponse => {
      if (rulesResponse.data.error) throw rulesResponse.data.error;
      const { items, pageState } = rulesResponse.data.data;
      if (items.length === 0 && pageState.page !== 0) {
        pageState.page = pageState.page - 1;
        dispatch(fetchRules(pageState.page, perPage));
      } else {
        dispatch(fetchRulesSuccess(items, pageState));
      }
    })
    .catch(error => {
      throw error;
    });
};

const fetchRulesWithoutAllocationRules = (
  page = 0,
  perPage = 10
) => dispatch => {
  dispatch(fetchingRules({ page, perPage }));
  axios
    .get(`${path}?page=${page}&perPage=${perPage}&isWithAllocationRules=false`)
    .then(rulesResponse => {
      if (rulesResponse.data.error) throw rulesResponse.data.error;
      const { items, pageState } = rulesResponse.data.data;
      if (items.length === 0 && pageState.page !== 0) {
        pageState.page = pageState.page - 1;
        dispatch(fetchRules(pageState.page, perPage));
      } else {
        dispatch(fetchRulesSuccess(items, pageState));
      }
    })
    .catch(error => {
      throw error;
    });
};

const fetchAllocationRules = (page = 0, perPage = 10) => dispatch => {
  dispatch(fetchingRules({ page, perPage }));
  axios
    .get(`${path}?page=${page}&perPage=${perPage}&subtype=ALLOCATION`)
    .then(rulesResponse => {
      if (rulesResponse.data.error) throw rulesResponse.data.error;
      const { items, pageState } = rulesResponse.data.data;
      if (items.length === 0 && pageState.page !== 0) {
        pageState.page = pageState.page - 1;
        dispatch(fetchAllocationRules(pageState.page, perPage));
      } else {
        dispatch(fetchRulesSuccess(items, pageState));
      }
    })
    .catch(error => {
      throw error;
    });
};

const rulesSubTypes = [
  { type: 'VALIDATION', value: 2 },
  { type: 'IGNORED', value: 1 },
  { type: 'POSTED', value: 3 },
  { type: 'ENRICHMENT', value: 0 },
  { type: 'ALLOCATION', value: 4 }
];

const backupRules = () => dispatch => dispatch(backupRulesSuccess());
const restoreRules = () => dispatch => dispatch(restoreRulesSuccess());
const updateSelectedRules = rule => dispatch =>
  dispatch(updateSelectedRulesSuccess(rule));
const addOrderedRules = () => dispatch => dispatch(addOrderedRulesSuccess());
const removeOrderedRule = (index, subtype) => dispatch =>
  dispatch(removeOrderedRuleSuccess(index, subtype));
const reOrderRules = (startIndex, endIndex, subtype) => dispatch =>
  dispatch(reOrderRulesSuccess(startIndex, endIndex, subtype));
const validateRule = rule => dispatch => {
  dispatch(validatingRule(dispatch));
  axios
    .post(`${path}/custom/check-syntax`, rule)
    .then(validateResponse => {
      if (validateResponse.data.success) {
        dispatch(
          validateRuleSuccess('The syntax check completed without errors.')
        );
      } else {
        dispatch(validateRuleSuccess(validateResponse.data.errors[0].message));
      }
    })
    .catch(error => {
      dispatch(validateRuleError());
      throw error;
    });
};
const createRule = (rule, pageState) => dispatch => {
  dispatch(creatingRule());
  axios
    .post(`${path}/custom`, { ...rule, priority: 1, type: 'sql' })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createRuleSuccess());
      dispatch(validationRuleReset());
      dispatch(fetchRules(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const fetchSubtypes = () => dispatch => {
  axios
    .get(`${path}/subtypes`)
    .then(subtypesResponse => {
      dispatch(fetchSubtypesSuccess(subtypesResponse.data.data.items));
    })
    .catch(error => {
      throw error;
    });
};

const resetRuleCreator = () => dispatch => dispatch(resetRuleCreatorSuccess());

const deleteRule = (ruleId, page, perPage) => dispatch => {
  axios
    .delete(`${path}/${ruleId}`)
    .then(() => {
      dispatch(fetchRules(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const updateRule = (rule, pageState) => dispatch => {
  dispatch(creatingRule());
  axios
    .put(`${path}/custom`, { ...rule, priority: 1, type: 'sql' })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createRuleSuccess());
      dispatch(validationRuleReset());
      dispatch(fetchRules(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const fetchRule = ruleId => dispatch => {
  dispatch(fetchingRule());
  axios
    .get(`${path}/${ruleId}`)
    .then(ruleResponse => {
      ruleResponse.data.data.thenCondition = rulesSubTypes.find(
        subType => subType.type === ruleResponse.data.data.subtype
      ).value;
      dispatch(fetchRuleSuccess(ruleResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const createAllocationRule = (rule, pageState) => dispatch => {
  dispatch(creatingRule());
  axios
    .post(`${path}/allocation`, { ...rule, priority: 0, type: 'allocation' })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createRuleSuccess());
      dispatch(validationRuleReset());
      dispatch(fetchRules(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const updateAllocationRule = (rule, pageState) => dispatch => {
  dispatch(creatingRule());
  axios
    .put(`${path}/allocation`, { ...rule, priority: 0, type: 'allocation' })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createRuleSuccess());
      dispatch(validationRuleReset());
      dispatch(fetchRules(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const applyAllocationRuleToLines = (allocationInformation, invoiceId, pageState, status) => dispatch => {
  dispatch(applyingAllocationRule());
  axios
    .post(`${path}/apply-allocation`, { ...allocationInformation })
    .then(() => {
      dispatch(allocationAppliedSuccess());
      dispatch(fetchInvoiceById(invoiceId));
      dispatch(fetchInvoicesLines(invoiceId, status, pageState.page, pageState.perPage));
    })
    .catch(error => {
      throw error;
    });
};

const applyAllocationRuleToLine = (
  allocationInformation,
  lineId
) => dispatch => {
  dispatch(applyingAllocationRule());
  axios
    .post(`${path}/apply-allocation`, { ...allocationInformation })
    .then(response => {
      if (response.data.status === 200) {
        dispatch(fetchInvoiceJurisdictionalBreakdown(lineId));
      }
      dispatch(allocationAppliedSuccess());
    })
    .catch(error => {
      throw error;
    });
};

export {
  fetchRules,
  fetchRule,
  backupRules,
  restoreRules,
  updateSelectedRules,
  addOrderedRules,
  removeOrderedRule,
  validateRule,
  reOrderRules,
  fetchSubtypes,
  createRule,
  resetRuleCreator,
  deleteRule,
  validationRuleReset,
  updateRule,
  createAllocationRule,
  updateAllocationRule,
  fetchRulesWithoutAllocationRules,
  fetchAllocationRules,
  applyAllocationRuleToLines,
  applyAllocationRuleToLine
};



// WEBPACK FOOTER //
// ./src/redux/rules/RulesActions.js